"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var constants_1 = require("../constants");
var defaultState = {
  providerWallet: null,
  address: null,
  chainId: null,
  isLoggedIn: false
};
var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case constants_1.SET_RROVIDER_WALLET:
      return Object.assign(Object.assign({}, state), {
        providerWallet: action.payload
      });
    case constants_1.SET_CHAIN_ID:
      return Object.assign(Object.assign({}, state), {
        chainId: action.payload
      });
    case constants_1.SET_ADDRESS:
      return Object.assign(Object.assign({}, state), {
        address: action.payload
      });
    case constants_1.SET_LOGIN_STATUS:
      return Object.assign(Object.assign({}, state), {
        isLoggedIn: action.payload
      });
    default:
      return state;
  }
};
exports["default"] = reducer;